import { URLS } from '@/constants';
import { BackfillJob, CreateJobParams, GetJobsParams } from '@/models/backfill';
import session from '@/services/session';

const baseUrl = `${URLS.BACKFILL.WEBHOOK_BACKFILL}/`;

export async function getJobs(payload: GetJobsParams) {
  const { owner, status } = payload;

  const params = { owner, status };

  const response = await session.get<{ results: BackfillJob[] }>(baseUrl, { params });

  return response.data;
}

export async function createJob(payload: CreateJobParams) {
  const response = await session.post<BackfillJob>(baseUrl, payload);

  return response.data;
}

export async function cancelJob({ ...data }: BackfillJob) {
  const url = `${baseUrl}${data.id}/`;

  const response = await session.patch(url, data);

  return response.data;
}
